export default __webpack_public_path__ + "static/media/gallery_22.68904c49.jpg";